import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from "@angular/forms";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { CnaeService } from "../services/external/cnae/cnae.service";

export function CnaeValidateByMCC(groupPrice, validateCnaeByMCCEnabled: () => boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!validateCnaeByMCCEnabled()) {
            return null;
        }

        let cnae = control.value;
        let cnaeList = groupPrice.cnaeListByMcc;
        
        if (cnae && cnaeList.length > 0) {
            if (!cnaeList.some(e => e.cnaeNumber === cnae)) {
                return { invalidCnae: { value: control.value } };
            }
        }
        return null;
    }
   
}

export function MccAbecsValidateByDocument(
    cnaeService: CnaeService,
    cnpjAbecsEnabled: () => boolean,
    getMccValue: () => string | number,
    setCnaeValidation?: (enabled: boolean) => void
): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
        const cnpj = (control.value || '').toString().replace(/[^a-zA-Z0-9]/g, '');
        const mccNumber = getMccValue();

        if (!cnpj || !mccNumber || !cnpjAbecsEnabled()) {
            return of(null);
        }

        return cnaeService.getMccAbecsByCnpj(cnpj).pipe(
            map((mccAbecs) => {
                if (mccAbecs == null) {
                    if (setCnaeValidation) {
                        setCnaeValidation(true);
                    }
                    return null;
                }

                if (setCnaeValidation) {
                    setCnaeValidation(false);
                }

                const expectedMcc = Number(mccNumber);
                const returnedMcc = Number(mccAbecs);

                if (Number.isNaN(expectedMcc) || Number.isNaN(returnedMcc)) {
                    return null;
                }

                return returnedMcc === expectedMcc
                    ? null
                    : { invalidMccAbecs: { value: control.value, mccAbecs: returnedMcc, mccNumber: expectedMcc } };
            }),
            catchError(() => of(null))
        );
    }
}